import { render, staticRenderFns } from "./OutsourcingVendorImportDialog.vue?vue&type=template&id=8f22bb5c&scoped=true&"
import script from "./OutsourcingVendorImportDialog.vue?vue&type=script&lang=js&"
export * from "./OutsourcingVendorImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingVendorImportDialog.vue?vue&type=style&index=0&id=8f22bb5c&lang=scss&scoped=true&"
import style1 from "./OutsourcingVendorImportDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22bb5c",
  null
  
)

export default component.exports